/**
 * Simple aspect that is used to suggest the type of input directive that
 * should be used based on the metadata for the property
 *
 * @param {Object} metadataType
 * @returns {String}
 */
function getInputCtrlType(metadataType) {
    var inputType = 'text';
    var isClass = metadataType.kind !== 'primitive';
    if (isClass && metadataType.typeInfo.metaType.isTypelist) {
        inputType = 'typelist';
    } else if (metadataType.name === 'Date') {
        inputType = 'date';
    } else if (metadataType.name === 'Integer') {
        inputType = 'number';
    } else if (metadataType.name === 'Boolean') {
        inputType = 'boolean';
    }
    return inputType;
}

export default {
    'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode /* , ancestorChain*/) {
        return {
            'inputCtrlType': {
                'get': function get() {
                    return getInputCtrlType(currentMetadataNode.valueType);
                }
            }
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/aspects/InputCtrlType.js
// module id = 938
// module chunks = 0